import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light p-4" }, "Student Report")
  ])
], -1)
const _hoisted_2 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_3 = { class: "collapse show" }
const _hoisted_4 = { class: "card-body border-top pt-7 p-9" }
const _hoisted_5 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "row col-12" }, null, -1)
const _hoisted_7 = { class: "row col-12" }
const _hoisted_8 = { class: "col-4 mt-10" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-12 dynamic-search" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "card mb-5 mb-xl-2" }
const _hoisted_13 = {
  class: "card-header border-0 cursor-pointer accordion-button",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#tranche",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_14 = { class: "card-title m-0" }
const _hoisted_15 = { class: "text-dark m-0 required" }
const _hoisted_16 = {
  id: "tranche",
  class: "collapse"
}
const _hoisted_17 = { class: "collapse show" }
const _hoisted_18 = {
  class: "card-body border-top",
  style: {"height":"10vh","padding-left":"0px","padding-right":"0px"}
}
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "card mb-5 mb-xl-2" }
const _hoisted_21 = {
  class: "card-header border-0 cursor-pointer accordion-button",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#test",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_22 = { class: "card-title m-0" }
const _hoisted_23 = { class: "text-dark m-0" }
const _hoisted_24 = {
  id: "test",
  class: "collapse"
}
const _hoisted_25 = { class: "collapse show" }
const _hoisted_26 = {
  class: "card-body border-top",
  style: {"height":"10vh","padding-left":"0px","padding-right":"0px"}
}
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "card mb-5 mb-xl-2" }
const _hoisted_29 = {
  class: "card-header border-0 cursor-pointer accordion-button",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#tI",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_30 = { class: "card-title m-0" }
const _hoisted_31 = { class: "text-dark m-0" }
const _hoisted_32 = {
  id: "tI",
  class: "collapse"
}
const _hoisted_33 = { class: "collapse show" }
const _hoisted_34 = {
  class: "card-body border-top",
  style: {"height":"10vh","padding-left":"0px","padding-right":"0px"}
}
const _hoisted_35 = { class: "row mt-3" }
const _hoisted_36 = { class: "card mb-5 mb-xl-2" }
const _hoisted_37 = {
  class: "card-header border-0 cursor-pointer accordion-button",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#course-list",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_38 = { class: "card-title m-0" }
const _hoisted_39 = { class: "text-dark m-0" }
const _hoisted_40 = {
  id: "course-list",
  class: "collapse"
}
const _hoisted_41 = { class: "collapse show" }
const _hoisted_42 = {
  class: "card-body border-top",
  style: {"height":"10vh","padding-left":"0px","padding-right":"0px"}
}
const _hoisted_43 = { class: "row mt-3" }
const _hoisted_44 = { class: "card mb-5 mb-xl-2" }
const _hoisted_45 = {
  class: "card-header border-0 cursor-pointer accordion-button",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#poor-data",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_46 = { class: "card-title m-0" }
const _hoisted_47 = { class: "text-dark m-0" }
const _hoisted_48 = {
  id: "poor-data",
  class: "collapse"
}
const _hoisted_49 = { class: "collapse show" }
const _hoisted_50 = {
  class: "card-body border-top",
  style: {"height":"10vh","padding-left":"0px","padding-right":"0px"}
}
const _hoisted_51 = { class: "row mt-3" }
const _hoisted_52 = { class: "card mb-5 mb-xl-2" }
const _hoisted_53 = {
  class: "card-header border-0 cursor-pointer accordion-button",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#ethnic-minority-data",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_54 = { class: "card-title m-0" }
const _hoisted_55 = { class: "text-dark m-0" }
const _hoisted_56 = {
  id: "ethnic-minority-data",
  class: "collapse"
}
const _hoisted_57 = { class: "collapse show" }
const _hoisted_58 = {
  class: "card-body border-top",
  style: {"height":"10vh","padding-left":"0px","padding-right":"0px"}
}
const _hoisted_59 = { class: "row mt-3" }
const _hoisted_60 = { class: "card mb-5 mb-xl-2" }
const _hoisted_61 = {
  class: "card-header border-0 cursor-pointer accordion-button",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#physically-data",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_62 = { class: "card-title m-0" }
const _hoisted_63 = { class: "text-dark m-0" }
const _hoisted_64 = {
  id: "physically-data",
  class: "collapse"
}
const _hoisted_65 = { class: "collapse show" }
const _hoisted_66 = {
  class: "card-body border-top",
  style: {"height":"10vh","padding-left":"0px","padding-right":"0px"}
}
const _hoisted_67 = { class: "row mt-3" }
const _hoisted_68 = { class: "card mb-5 mb-xl-2" }
const _hoisted_69 = {
  class: "card-header border-0 cursor-pointer accordion-button",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#gender-data",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_70 = { class: "card-title m-0" }
const _hoisted_71 = { class: "text-dark m-0" }
const _hoisted_72 = {
  id: "gender-data",
  class: "collapse"
}
const _hoisted_73 = { class: "collapse show" }
const _hoisted_74 = {
  class: "card-body border-top",
  style: {"height":"10vh","padding-left":"0px","padding-right":"0px"}
}
const _hoisted_75 = { class: "row mt-3" }
const _hoisted_76 = { class: "col-md-12" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-restore-alt" }, null, -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_79 = { class: "col-8" }
const _hoisted_80 = { class: "col-md-12 mt-1" }
const _hoisted_81 = { class: "row d-flex" }
const _hoisted_82 = { class: "col-md-5" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("h3", null, "Select Header", -1)
const _hoisted_84 = { class: "card mb-5 mb-xl-2" }
const _hoisted_85 = {
  class: "card-header border-0 cursor-pointer accordion-button bg-secondary",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#header",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_86 = { class: "card-title m-0" }
const _hoisted_87 = { class: "text-dark m-0" }
const _hoisted_88 = { key: 0 }
const _hoisted_89 = {
  id: "header",
  class: "collapse"
}
const _hoisted_90 = { class: "collapse show" }
const _hoisted_91 = {
  class: "card-body border-top p-9",
  style: {"overflow":"scroll","max-height":"28vh"}
}
const _hoisted_92 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_93 = { class: "row" }
const _hoisted_94 = ["name", "onUpdate:modelValue", "value"]
const _hoisted_95 = ["for"]
const _hoisted_96 = { class: "col-md-5 mt-8" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_98 = {
  key: 0,
  class: "col-md-12 mt-4"
}
const _hoisted_99 = /*#__PURE__*/_createElementVNode("h3", null, "Selected Headers", -1)
const _hoisted_100 = { key: 0 }
const _hoisted_101 = { class: "row" }
const _hoisted_102 = ["onUpdate:modelValue"]
const _hoisted_103 = { class: "row col-12" }
const _hoisted_104 = {
  key: 0,
  class: "row mt-1 w-100 m-0"
}
const _hoisted_105 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_106 = {
  class: "col-md-6 mt-1 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_107 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_108 = [
  _hoisted_107
]
const _hoisted_109 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_110 = [
  _hoisted_109
]
const _hoisted_111 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_112 = [
  _hoisted_111
]
const _hoisted_113 = {
  key: 1,
  class: "row"
}
const _hoisted_114 = {
  class: "col-md-12 mt-4",
  id: "dataTable"
}
const _hoisted_115 = { class: "row" }
const _hoisted_116 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_117 = { style: {"float":"left","font-weight":"bold"} }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_119 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_120 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_121 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "card mb-5 mb-xl-10",
    key: _ctx.componentKey
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("label", _hoisted_15, [
                              _createElementVNode("span", null, _toDisplayString(this.optionsTranche.length) + " Tranche", 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _createVNode(_component_Multiselect, {
                                style: {"margin":"-31 auto !important"},
                                modelValue: _ctx.TranceData,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.TranceData) = $event)),
                                options: _ctx.optionsTranche,
                                mode: "tags",
                                "clear-on-select": false,
                                placeholder: "Select Tranche",
                                "close-on-select": false,
                                searchable: true,
                                "create-option": true
                              }, null, 8, ["modelValue", "options"])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("label", _hoisted_23, [
                              _createElementVNode("span", null, _toDisplayString(this.optionsTPartner.length) + " Training Partner", 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_Multiselect, {
                                style: {"margin":"-31 auto !important"},
                                modelValue: _ctx.TpartnerData,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.TpartnerData) = $event)),
                                options: _ctx.optionsTPartner,
                                mode: "tags",
                                "clear-on-select": false,
                                placeholder: "Select Training Partner",
                                "close-on-select": false,
                                searchable: true,
                                "create-option": true
                              }, null, 8, ["modelValue", "options"])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("label", _hoisted_31, [
                              _createElementVNode("span", null, _toDisplayString(this.instituteList.length) + " Training Institute", 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Training Institute",
                                modelValue: _ctx.batch.institute_id,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.institute_id) = $event)),
                                name: "course_id",
                                filterable: "",
                                style: {"width":"100%"},
                                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.courseInfo(_ctx.batch.institute_id)))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteList, (info) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: info.id,
                                      label: info.short_name,
                                      value: info.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(info.institute_name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("label", _hoisted_39, [
                              _createElementVNode("span", null, _toDisplayString(this.courseList.length) + " Training Course ", 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, [
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Course",
                                modelValue: _ctx.batch.course_id,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.batch.course_id) = $event)),
                                name: "course_id",
                                filterable: "",
                                style: {"width":"100%"},
                                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.courseLabelChange(_ctx.batch.course_id)))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseList, (info) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: info.id,
                                      label: info.course_name,
                                      value: info.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(info.course_name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("label", _hoisted_47, [
                              _createElementVNode("span", null, _toDisplayString(this.poorSearchoption.length) + " Poor ", 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("div", _hoisted_50, [
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Poor",
                                modelValue: _ctx.batch.poor,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.batch.poor) = $event)),
                                name: "course_id",
                                filterable: "",
                                style: {"width":"100%"},
                                onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.poorLabelChange(_ctx.batch.poor)))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.poorSearchoption, (info) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: info.value,
                                      label: info.name,
                                      value: info.value
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(info.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("label", _hoisted_55, [
                              _createElementVNode("span", null, _toDisplayString(this.ethnicoption.length) + " Ethnic Minority ", 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("div", _hoisted_58, [
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select ethnic",
                                modelValue: _ctx.batch.ethnic,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.batch.ethnic) = $event)),
                                name: "course_id",
                                filterable: "",
                                style: {"width":"100%"},
                                onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.ethnicLabelChange(_ctx.batch.ethnic)))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ethnicoption, (info) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: info.value,
                                      label: info.name,
                                      value: info.value
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(info.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("label", _hoisted_63, [
                              _createElementVNode("span", null, _toDisplayString(this.challengedoption.length) + " Physically Challenged ", 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("div", _hoisted_66, [
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Challenged",
                                modelValue: _ctx.batch.challenged,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.batch.challenged) = $event)),
                                name: "course_id",
                                filterable: "",
                                style: {"width":"100%"},
                                onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.physicalLabelChange(_ctx.batch.challenged)))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.challengedoption, (info) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: info.value,
                                      label: info.name,
                                      value: info.value
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(info.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("div", _hoisted_70, [
                            _createElementVNode("label", _hoisted_71, [
                              _createElementVNode("span", null, _toDisplayString(this.genderoption.length) + " Gender ", 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, [
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Gender",
                                modelValue: _ctx.batch.gender,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.batch.gender) = $event)),
                                name: "course_id",
                                filterable: "",
                                style: {"width":"100%"},
                                onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.genderLabelChange(_ctx.batch.gender)))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.genderoption, (info) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: info.value,
                                      label: info.name,
                                      value: info.value
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(info.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("button", {
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.resetData())),
                          type: "button",
                          class: "btn btn-danger p-3 mr-4",
                          style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                        }, [
                          _createTextVNode(" Reset "),
                          _hoisted_77
                        ]),
                        _createElementVNode("button", {
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.generateInstituteReport())),
                          type: "button",
                          class: "btn btn-success p-3",
                          style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                        }, [
                          _createTextVNode(" Search "),
                          _hoisted_78
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("div", _hoisted_82, [
                      _hoisted_83,
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("div", _hoisted_85, [
                          _createElementVNode("div", _hoisted_86, [
                            _createElementVNode("label", _hoisted_87, [
                              (_ctx.headerSelect)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_88, _toDisplayString(_ctx.st.length) + " Selected", 1))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_89, [
                          _createElementVNode("div", _hoisted_90, [
                            _createElementVNode("div", _hoisted_91, [
                              _createElementVNode("div", _hoisted_92, [
                                _createElementVNode("div", _hoisted_93, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (info) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "form-check",
                                      key: info.key
                                    }, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        multiple: "",
                                        name: info.name,
                                        "onUpdate:modelValue": ($event: any) => ((info.selected) = $event),
                                        value: {
                                      name: info.name,
                                      key: info.key,
                                    },
                                        class: "form-check-input"
                                      }, null, 8, _hoisted_94), [
                                        [_vModelCheckbox, info.selected]
                                      ]),
                                      _createElementVNode("label", {
                                        class: "form-check-label",
                                        for: info.name
                                      }, _toDisplayString(info.name), 9, _hoisted_95)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_96, [
                      _createElementVNode("button", {
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.generateInstituteReport())),
                        type: "button",
                        class: "btn btn-success p-3"
                      }, [
                        _createTextVNode(" Search "),
                        _hoisted_97
                      ])
                    ]),
                    (_ctx.showall)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                          _hoisted_99,
                          (_ctx.st.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                _createElementVNode("div", _hoisted_101, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.st, (data, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "col-md-3",
                                      key: index
                                    }, [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "btn btn-primary m-1 py-2 px-2 w-100",
                                        "onUpdate:modelValue": ($event: any) => ((data.name) = $event)
                                      }, null, 8, _hoisted_102), [
                                        [_vModelText, data.name]
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_103, [
              (_ctx.showTableData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                    _hoisted_105,
                    _createElementVNode("div", _hoisted_106, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                        title: "Download Xlse",
                        "data-v-54b12dc8": "",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.exportTrainee()))
                      }, _hoisted_108),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                        title: "Download PDF",
                        "data-v-54b12dc8": "",
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.downloadPdf()))
                      }, _hoisted_110),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                        title: "Print",
                        "data-v-54b12dc8": "",
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.printPdf()))
                      }, _hoisted_112)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showTableData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                    _createElementVNode("div", _hoisted_114, [
                      _createElementVNode("div", _hoisted_115, [
                        (_openBlock(), _createElementBlock("div", {
                          key: _ctx.componentTableKey,
                          class: "card-body p-6",
                          "data-v-71816626": "",
                          style: {"border-radius":"1em","border":"2px solid #8dcb8d"}
                        }, [
                          _createElementVNode("div", _hoisted_116, [
                            _createElementVNode("p", _hoisted_117, " Total: (" + _toDisplayString(_ctx.tableData.length) + ")", 1),
                            _hoisted_118,
                            _hoisted_119,
                            _hoisted_120,
                            _createVNode(_component_Datatable, {
                              "table-data": _ctx.tableData,
                              "table-header": _ctx.st,
                              "enable-items-per-page-dropdown": true
                            }, {
                              "cell-tranche": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.tranche_info?.label), 1)
                              ]),
                              "cell-entity": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.entity_info?.entity_short_name), 1)
                              ]),
                              "cell-photo": _withCtx(({ row: industry }) => [
                                _createElementVNode("img", {
                                  style: {"width":"20%"},
                                  src: 
                              _ctx.apiUrl + industry?.attach_file_info?.file_path
                            ,
                                  alt: ""
                                }, null, 8, _hoisted_121)
                              ]),
                              "cell-institute_name": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.institute_info?.short_name), 1)
                              ]),
                              "cell-reg_number": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.registration_number), 1)
                              ]),
                              "cell-mobile": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.mobile), 1)
                              ]),
                              "cell-name": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.trainee_name), 1)
                              ]),
                              "cell-nid": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.nid), 1)
                              ]),
                              "cell-bcn": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.bcn), 1)
                              ]),
                              "cell-gender": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.gender), 1)
                              ]),
                              "cell-present_add": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.present_address), 1)
                              ]),
                              "cell-present_city": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.present_district_info?.district_name_eng), 1)
                              ]),
                              "cell-postCode": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.present_post_code), 1)
                              ]),
                              "cell-present_district": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.present_district_info?.district_name_eng), 1)
                              ]),
                              "cell-batch_number": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.batch_info?.batch_sequence_number), 1)
                              ]),
                              "cell-email": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.email), 1)
                              ]),
                              "cell-active_status": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry.active_status ? 'Active' : 'Inactive'), 1)
                              ]),
                              _: 1
                            }, 8, ["table-data", "table-header"])
                          ])
                        ]))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}